module.exports = __webpack_public_path__ + "static/media/logo-booking.032a0f92.png";